import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full fixed bg-black bg-opacity-25 z-10 top-0 left-0 right-0 bottom-0 flex items-center justify-center" }
const _hoisted_2 = { class: "t-16m md:t-22m lg:t-28m text-wrh-blue-dark" }
const _hoisted_3 = { class: "t-12r md:t-14r xl:t-16r text-wrh-blue-dark mt-2" }
const _hoisted_4 = { class: "flex justify-between mt-6" }

import {
  PropType, ref,
} from 'vue';
import { onClickOutside } from '@vueuse/core';
import type { ModalData } from '@/types';


export default /*#__PURE__*/_defineComponent({
  props: {
  modalData: {
    type: Object as PropType<ModalData>,
    required: true,
  },
},
  emits: ['cancel', 'confirm'],
  setup(__props, { emit }) {



const target = ref(null);
onClickOutside(target, () => {
  emit('cancel');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['target'] = _value
        target.value = _value
      },
      class: "bg-white shadow-modal rounded-xl p-4 md:p-6 w-[210px] md:w-xs lg:w-md"
    }, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.modalData.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.modalData.description), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "bg-wrh-blue-light text-white tracking-wide rounded t-12m md:t-14m uppercase w-1/2 py-2 focus:outline-none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
        }, _toDisplayString(__props.modalData.cancelActionText), 1),
        _createElementVNode("button", {
          class: "border-wrh-blue-light text-wrh-blue-light tracking-wide border rounded t-12m md:t-14m uppercase w-1/2 py-2 ml-1 md:ml-6 focus:outline-none",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
        }, _toDisplayString(__props.modalData.confirmActionText), 1)
      ])
    ], 512)
  ]))
}
}

})